import { z } from 'zod';
/** Browsable row from raw_messages — debug view, not for downstream consumers. */
export const RawMessageBrowseRow = z.object({
    id: z.string().uuid(),
    groupId: z.string().uuid(),
    groupTitle: z.string().nullable(),
    tgChatId: z.string(),
    accountId: z.string().uuid(),
    tgMessageId: z.string(),
    senderUserId: z.string(),
    senderUsername: z.string().nullable(),
    senderFirstName: z.string().nullable(),
    text: z.string(),
    ts: z.string().datetime(),
});
export const RawMessageBrowseResponse = z.object({
    items: z.array(RawMessageBrowseRow),
    nextCursor: z.string().nullable(),
});
//# sourceMappingURL=raw-message.js.map